import React from 'react';
import { Helmet } from 'react-helmet-async';
import HeroSection from '../components/LandingPage/HeroSection';
import UniversityIconSection from '../components/LandingPage/UniversityIconSection';
import BrowseSection from '../components/LandingPage/BrowseSection';
import ProcessSection from '../components/LandingPage/ProcessSection';
import SloganBannerSection from '../components/LandingPage/SloganBannerSection';
import FAQSection from '../components/LandingPage/FAQSection';
import FeaturesSection from '../components/LandingPage/FeaturesSection';
import BecomeTutorSection from '../components/LandingPage/BecomeTutorSection';
import { buildPageSEO, organizationSchema, localBusinessSchema } from '@/utils/seo';
import { useI18n } from '@/i18n';

const LandingPage: React.FC = () => {
  const { locale } = useI18n();
  const seo = buildPageSEO(
    locale === 'zh-CN' ? '在马来西亚找到最适合的导师' : 'Find Your Perfect Tutor in Malaysia',
    locale === 'zh-CN'
      ? '马来西亚导师配对平台。为孩子寻找经过审核的优质导师，或提交你的补习需求，快速连接合适导师。'
      : "Malaysia's tutor matching platform. Find qualified, verified tutors for your child or post your case to connect with the right tutor today.",
    '/',
  );

  return (
    <>
      <Helmet>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <link rel="canonical" href={seo.canonical} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={seo.canonical} />
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta property="og:image" content={seo.ogImage} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seo.title} />
        <meta name="twitter:description" content={seo.description} />
        <meta name="twitter:image" content={seo.ogImage} />
        <script type="application/ld+json">{JSON.stringify(organizationSchema())}</script>
        <script type="application/ld+json">{JSON.stringify(localBusinessSchema())}</script>
      </Helmet>

      <div>
        <HeroSection />
        <UniversityIconSection />
        <BrowseSection type="tutor" />
        <FeaturesSection />
        <ProcessSection />
        <SloganBannerSection />
        <FAQSection />
        <BecomeTutorSection />
      </div>
    </>
  );
};

export default LandingPage;
